module.exports = __webpack_public_path__ + "static/img/pc4.1598a08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/pc4.png
// module id = X4Q+
// module chunks = 1